"use strict";

module.exports = {
    "account_box": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M15 2h-12c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-12c0-.55-.45-1-1-1zm-6 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25-2.25-1.01-2.25-2.25 1.01-2.25 2.25-2.25zm4.5 9.25h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25v.75z"
    }],
    "account_circle": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M9 1c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25-2.25-1.01-2.25-2.25 1.01-2.25 2.25-2.25zm0 10.75c-1.86 0-3.49-.92-4.49-2.33.11-1.45 3.02-2.17 4.49-2.17 1.47 0 4.38.72 4.49 2.17-1 1.41-2.63 2.33-4.49 2.33z"
    }],
    "event": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M13 9h-4v4h4v-4zm2-7h-1v-1h-2v1h-6v-1h-2v1h-1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-12c0-.55-.45-1-1-1zm-1 12h-10v-8h10v8z"
    }],
    "error": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M9 1.03c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm1 11.97h-2v-2h2v2zm0-3h-2v-5h2v5z"
    }],
    "warning": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M.5 16h17l-8.5-15-8.5 15zm9.5-2h-2v-2h2v2zm0-3h-2v-4h2v4z"
    }],
    "volume_down": [{
        "d": "M0 0h18v18H0z",
        "fill": "none"
    }, {
        "d": "M4 7v4h3l4 4V3L7 7H4zm9-1v6c1.17-.49 2-1.65 2-3s-.83-2.51-2-3z"
    }],
    "volume_mute": [{
        "d": "M0 0h18v18H0z",
        "fill": "none"
    }, {
        "d": "M5 7v4h3l4 4V3L8 7H5z"
    }],
    "volume_up": [{
        "d": "M0 0h18v18H0z",
        "fill": "none"
    }, {
        "d": "M12.79 9c0-1.3-.72-2.42-1.79-3v6c1.06-.58 1.79-1.7 1.79-3zM2 7v4h3l4 4V3L5 7H2zm9-5v1.5c2.32.74 4 2.93 4 5.5s-1.68 4.76-4 5.5V16c3.15-.78 5.5-3.6 5.5-7S14.15 2.78 11 2z"
    }],
    "battery_20": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "fill-opacity": ".3",
        "d": "M13 4c0-.55-.45-1-1-1h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v8.5h8v-8.5z"
    }, {
        "d": "M5 12.5v2.5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.5h-8z"
    }],
    "battery_30": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "fill-opacity": ".3",
        "d": "M13 4c0-.55-.45-1-1-1h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v7.5h8v-7.5z"
    }, {
        "d": "M5 11.5v3.5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-3.5h-8z"
    }],
    "battery_50": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "fill-opacity": ".3",
        "d": "M13 4c0-.55-.45-1-1-1h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v5.5h8v-5.5z"
    }, {
        "d": "M5 9.5v5.5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-5.5h-8z"
    }],
    "battery_60": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "fill-opacity": ".3",
        "d": "M13 4c0-.55-.45-1-1-1h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v4.5h8v-4.5z"
    }, {
        "d": "M5 8.5v6.5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-6.5h-8z"
    }],
    "battery_80": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "fill-opacity": ".3",
        "d": "M13 4c0-.55-.45-1-1-1h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v2.5h8v-2.5z"
    }, {
        "d": "M5 6.5v8.5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-8.5h-8z"
    }],
    "battery_90": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "fill-opacity": ".3",
        "d": "M13 4c0-.55-.45-1-1-1h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v1.5h8v-1.5z"
    }, {
        "d": "M5 5.5v9.5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-9.5h-8z"
    }],
    "battery_alert": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M12 3h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-11c0-.55-.45-1-1-1zm-2 10h-2v-2h2v2zm0-3h-2v-4h2v4z"
    }],
    "battery_charging_20": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "fill-opacity": ".3",
        "d": "M12 3h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v8.5h3.5v-2h-2l3-6v4h2l-2 4h3.5v-8.5c0-.55-.45-1-1-1z"
    }, {
        "d": "M8.5 14.5v-2h-3.5v2.5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.5h-3.5l-1 2z"
    }],
    "battery_charging_30": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "fill-opacity": ".3",
        "d": "M12 3h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v6.5h1.5l3-6v4h2l-1 2h2.5v-6.5c0-.55-.45-1-1-1z"
    }, {
        "d": "M8.5 14.5v-4h-3.5v4.5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-4.5h-2.5l-2 4z"
    }],
    "battery_charging_50": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "fill-opacity": ".3",
        "d": "M12 3h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v5.5h2l2.5-5v4h2l-.5 1h2v-5.5c0-.55-.45-1-1-1z"
    }, {
        "d": "M8.5 14.5v-4h-2l.5-1h-2v5.5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-5.5h-2l-2.5 5z"
    }],
    "battery_charging_60": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "fill-opacity": ".3",
        "d": "M12 3h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v4.5h2.5l2-4v4h3.5v-4.5c0-.55-.45-1-1-1z"
    }, {
        "d": "M8.5 14.5v-4h-2l1-2h-2.5v6.5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-6.5h-1.5l-3 6z"
    }],
    "battery_charging_80": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "fill-opacity": ".3",
        "d": "M12 3h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v2.5h3.5l1-2v2h3.5v-2.5c0-.55-.45-1-1-1z"
    }, {
        "d": "M9.5 8.5h2l-3 6v-4h-2l2-4h-3.5v8.5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-8.5h-3.5v2z"
    }],
    "battery_charging_90": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "fill-opacity": ".3",
        "d": "M12 3h-1v-1.5h-4v1.5h-1c-.55 0-1 .45-1 1v1.5h4l.5-1v1h3.5v-1.5c0-.55-.45-1-1-1z"
    }, {
        "d": "M9.5 8.5h2l-3 6v-4h-2l2.5-5h-4v9.5c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-9.5h-3.5v3z"
    }],
    "battery_charging_full": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M12 3h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-11c0-.55-.45-1-1-1zm-3.5 11.5v-4h-2l3-6v4h2l-3 6z"
    }],
    "battery_full": [{
        "d": "M12 3h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-11c0-.55-.45-1-1-1z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "battery_std": [{
        "d": "M12 3h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-11c0-.55-.45-1-1-1z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "battery_unknown": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M12 3h-1.5v-1.5h-3v1.5h-1.5c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-11c0-.55-.45-1-1-1zm-2.2 10.8h-1.6v-1.6h1.6v1.6zm1.12-4.89s-.32.35-.56.59c-.4.4-.69 1.12-.69 1.5h-1.47c0-.69.52-1.44.91-1.83l.78-.79c.23-.23.37-.54.37-.88 0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25 1.25h-1.26c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5c0 .55-.22 1.05-.58 1.41z"
    }],
    "network_cell": [{
        "fill-opacity": ".3",
        "d": "M1 16h15v-15z"
    }, {
        "d": "M1 16h11v-11z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "network_wifi": [{
        "fill-opacity": ".3",
        "d": "M9.01 15.99l8.8-10.96c-.34-.26-3.73-3.03-8.81-3.03s-8.47 2.77-8.81 3.03l8.8 10.96h.02z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M2.73 8.19l6.27 7.8v.01l.01-.01 6.27-7.8c-.32-.25-2.72-2.19-6.28-2.19s-5.96 1.94-6.27 2.19z"
    }],
    "now_wallpaper": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M13 6c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zm-4.71 6.93l-1.79-2.14-2.5 3.21h10l-3.21-4.29-2.5 3.22zm-5.29-9.93h5v-2h-5c-1.1 0-2 .9-2 2v5h2v-5zm12 12h-5v2h5c1.1 0 2-.9 2-2v-5h-2v5zm-12-5h-2v5c0 1.1.9 2 2 2h5v-2h-5v-5zm12-9h-5v2h5v5h2v-5c0-1.1-.9-2-2-2z"
    }],
    "now_widgets": [{
        "d": "M10 10v6h6v-6h-6zm-8-2h6v-6h-6v6zm0 8h6v-6h-6v6zm8 0h6v-6h-6v6zm7.25-11l-4.25-4.25-4.25 4.25 4.25 4.25 4.25-4.25z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "signal_cellular_0_bar": [{
        "fill-opacity": ".3",
        "d": "M1 16h15v-15z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "signal_cellular_1_bar": [{
        "fill-opacity": ".3",
        "d": "M1 16h15v-15z"
    }, {
        "d": "M1 16h7v-7z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "signal_cellular_2_bar": [{
        "fill-opacity": ".3",
        "d": "M1 16h15v-15z"
    }, {
        "d": "M1 16h9v-9z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "signal_cellular_3_bar": [{
        "fill-opacity": ".3",
        "d": "M1 16h15v-15z"
    }, {
        "d": "M1 16h11v-11z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "signal_cellular_4_bar": [{
        "d": "M1 16h15v-15z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "signal_cellular_connected_no_internet_0_bar": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M12 5h4v-4zm0 11v-11l-11 11z",
        "fill-opacity": ".3"
    }, {
        "d": "M14 16h2v-2h-2v2zm0-9v5h2v-5h-2z"
    }],
    "signal_cellular_connected_no_internet_1_bar": [{
        "d": "M12 16v-11l-11 11zm0-11h4v-4z",
        "fill-opacity": ".3"
    }, {
        "d": "M14 16h2v-2h-2v2zm-6 0v-7l-7 7h7zm6-9v5h2v-5h-2z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "signal_cellular_connected_no_internet_2_bar": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M16 1l-4 4h4zm-15 15h11v-11z",
        "fill-opacity": ".3"
    }, {
        "d": "M10 16v-9l-9 9h9zm4-9v5h2v-5h-2zm0 9h2v-2h-2v2z"
    }],
    "signal_cellular_connected_no_internet_3_bar": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "fill-opacity": ".3",
        "d": "M1 16h11v-11zm15-15l-4 4h4z"
    }, {
        "d": "M12 16v-11l-11 11h11zm2-9v5h2v-5h-2zm0 9h2v-2h-2v2z"
    }],
    "signal_cellular_connected_no_internet_4_bar": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M12 5h4v-4zm2 11h2v-2h-2v2zm0-9v5h2v-5h-2zm-2 9v-11l-11 11z"
    }],
    "signal_cellular_null": [{
        "d": "M14 5.83v8.17h-8.17l8.17-8.17m2-4.83l-15 15h15v-15z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "signal_cellular_off": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M15.5 1l-6.19 6.19 6.19 6.19v-12.38zm-11.92 2.37l-.96.96 4.78 4.77-6.4 6.4h12.8l.25.25 1.5 1.5.95-.95-12.92-12.93z"
    }],
    "signal_wifi_0_bar": [{
        "fill-opacity": ".3",
        "d": "M9.01 15.99l8.8-10.96c-.34-.26-3.73-3.03-8.81-3.03s-8.47 2.77-8.81 3.03l8.8 10.96h.02z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "signal_wifi_1_bar": [{
        "fill-opacity": ".3",
        "d": "M9.01 15.99l8.8-10.96c-.34-.26-3.73-3.03-8.81-3.03s-8.47 2.77-8.81 3.03l8.8 10.96h.02z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M5.24 11.31l3.76 4.69 3.76-4.68c-.19-.15-1.62-1.32-3.76-1.32-2.14 0-3.57 1.17-3.76 1.31z"
    }],
    "signal_wifi_2_bar": [{
        "fill-opacity": ".3",
        "d": "M9.01 15.99l8.8-10.96c-.34-.26-3.73-3.03-8.81-3.03s-8.47 2.77-8.81 3.03l8.8 10.96h.02z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M3.98 9.75l5.01 6.24.01.01v-.01l5.01-6.24c-.25-.19-2.16-1.75-5.01-1.75-2.85 0-4.76 1.56-5.02 1.75z"
    }],
    "signal_wifi_3_bar": [{
        "fill-opacity": ".3",
        "d": "M9.01 15.99l8.8-10.96c-.34-.26-3.73-3.03-8.81-3.03s-8.47 2.77-8.81 3.03l8.8 10.96h.02z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M2.73 8.19l6.27 7.8v.01l.01-.01 6.27-7.8c-.32-.25-2.72-2.19-6.28-2.19s-5.96 1.94-6.27 2.19z"
    }],
    "signal_wifi_4_bar": [{
        "d": "M9.01 15.99l8.8-10.96c-.34-.26-3.73-3.03-8.81-3.03s-8.47 2.77-8.81 3.03l8.8 10.96h.02z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "signal_wifi_off": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M17.81 5.03c-.34-.26-3.73-3.03-8.81-3.03-1.21 0-2.32.16-3.32.4l7.9 7.89 4.23-5.26zm-16.31-2.99l1.36 1.36c-1.55.73-2.5 1.5-2.67 1.63l8.8 10.96.01.01.01-.01 2.87-3.58.06.06 2.49 2.49.95-.96-12.93-12.92-.95.96z"
    }],
    "usb": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M11 6.5v2h.5v1.5h-2v-5h1.5l-2-3-2 3h1.5v5h-2v-1.54c.35-.18.6-.54.6-.96 0-.61-.49-1.1-1.1-1.1-.61 0-1.1.49-1.1 1.1 0 .42.25.78.6.96v1.54c0 .55.45 1 1 1h2v2.09c-.58.21-1 .76-1 1.41 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.65-.42-1.2-1-1.41v-2.09h2c.55 0 1-.45 1-1v-1.5h.5v-2h-2z"
    }],
    "attach_file": [{
        "d": "M13 14c0 2.21-1.79 4-4 4s-4-1.79-4-4v-11c0-1.66 1.34-3 3-3s3 1.34 3 3v9c0 1.1-.9 2-2 2s-2-.9-2-2v-8h1v8c0 .55.45 1 1 1s1-.45 1-1v-9c0-1.1-.9-2-2-2s-2 .9-2 2v11c0 1.66 1.34 3 3 3s3-1.34 3-3v-10h1v10z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "attach_money": [{
        "d": "M9.56 8.1c-1.6-.51-2.66-.71-2.66-1.88 0-.83.72-1.62 2.1-1.62 1.59 0 2.1.88 2.1 1.94h1.9c0-1.79-1.17-3.09-3-3.44v-2.1h-2v2.11c-1.58.32-3 1.37-3 3.12 0 2.25 1.78 2.8 4 3.52 1.88.61 2.25 1.04 2.25 2.09 0 .9-.67 1.56-2.25 1.56-1.2 0-2.25-.84-2.25-2.06h-2c0 1.88 1.38 3.2 3.25 3.56v2.1h2v-2.07c2.04-.29 3.2-1.49 3.2-3.1 0-1.87-.94-2.87-3.64-3.73z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "border_all": [{
        "d": "M2 2v14h14v-14h-14zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm6 6h-4v-4h4v4zm0-6h-4v-4h4v4z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "border_bottom": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M7 2h-2v2h2v-2zm3 6h-2v2h2v-2zm0 3h-2v2h2v-2zm3-3h-2v2h2v-2zm-6 0h-2v2h2v-2zm6-6h-2v2h2v-2zm-3 3h-2v2h2v-2zm0-3h-2v2h2v-2zm-6 9h-2v2h2v-2zm10 2h2v-2h-2v2zm0-6h2v-2h-2v2zm0 3h2v-2h-2v2zm0-8v2h2v-2h-2zm-10 0h-2v2h2v-2zm-2 14h14v-2h-14v2zm2-11h-2v2h2v-2zm0 3h-2v2h2v-2z"
    }],
    "border_clear": [{
        "d": "M8 16h2v-2h-2v2zm-3-6h2v-2h-2v2zm0-6h2v-2h-2v2zm3 9h2v-2h-2v2zm-3 3h2v-2h-2v2zm-3-9h2v-2h-2v2zm0 9h2v-2h-2v2zm0-12h2v-2h-2v2zm0 6h2v-2h-2v2zm6 0h2v-2h-2v2zm-6 3h2v-2h-2v2zm12 0h2v-2h-2v2zm0 3h2v-2h-2v2zm0-6h2v-2h-2v2zm0-3h2v-2h-2v2zm0-5v2h2v-2h-2zm-6 2h2v-2h-2v2zm3 0h2v-2h-2v2zm-3 3h2v-2h-2v2zm3 9h2v-2h-2v2zm0-6h2v-2h-2v2z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "border_color": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "fill-opacity": ".36",
        "d": "M0 15h18v3h-18z"
    }, {
        "d": "M13.38 5.5l-2.88-2.88-7.5 7.5v2.88h2.88l7.5-7.5zm2.47-2.48c.2-.2.2-.51 0-.71l-2.17-2.17c-.2-.2-.51-.2-.71 0l-1.35 1.36 2.88 2.88 1.35-1.36z"
    }],
    "border_horizontal": [{
        "d": "M8 16h2v-2h-2v2zm-3-12h2v-2h-2v2zm3 9h2v-2h-2v2zm-3 3h2v-2h-2v2zm-3-9h2v-2h-2v2zm0 9h2v-2h-2v2zm0-12h2v-2h-2v2zm0 6h14v-2h-14v2zm0 3h2v-2h-2v2zm12 0h2v-2h-2v2zm0 3h2v-2h-2v2zm0-9h2v-2h-2v2zm0-5v2h2v-2h-2zm-6 2h2v-2h-2v2zm3 0h2v-2h-2v2zm-3 3h2v-2h-2v2zm3 9h2v-2h-2v2z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "border_inner": [{
        "d": "M2 16h2v-2h-2v2zm2-11h-2v2h2v-2zm1 11h2v-2h-2v2zm8-14h-2v2h2v-2zm-9 0h-2v2h2v-2zm3 0h-2v2h2v-2zm-5 11h2v-2h-2v2zm9 3h2v-2h-2v2zm-1-14h-2v6h-6v2h6v6h2v-6h6v-2h-6v-6zm4 0v2h2v-2h-2zm0 5h2v-2h-2v2zm0 9h2v-2h-2v2zm0-3h2v-2h-2v2z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "border_left": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M8 10h2v-2h-2v2zm0-3h2v-2h-2v2zm0 6h2v-2h-2v2zm0 3h2v-2h-2v2zm-6 0h2v-14h-2v14zm3 0h2v-2h-2v2zm0-12h2v-2h-2v2zm0 6h2v-2h-2v2zm9 6h2v-2h-2v2zm0-6h2v-2h-2v2zm0 3h2v-2h-2v2zm0-6h2v-2h-2v2zm-6-3h2v-2h-2v2zm6-2v2h2v-2h-2zm-3 14h2v-2h-2v2zm0-6h2v-2h-2v2zm0-6h2v-2h-2v2z"
    }],
    "border_outer": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M10 5h-2v2h2v-2zm3 3h-2v2h2v-2zm-3 0h-2v2h2v-2zm0 3h-2v2h2v-2zm-3-3h-2v2h2v-2zm-5-6v14h14v-14h-14zm12 12h-10v-10h10v10z"
    }],
    "border_right": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M2 4h2v-2h-2v2zm3 0h2v-2h-2v2zm0 6h2v-2h-2v2zm0 6h2v-2h-2v2zm-3-9h2v-2h-2v2zm0 3h2v-2h-2v2zm0 6h2v-2h-2v2zm0-3h2v-2h-2v2zm9-3h2v-2h-2v2zm-3 6h2v-2h-2v2zm3 0h2v-2h-2v2zm3-14v14h2v-14h-2zm-6 2h2v-2h-2v2zm3 0h2v-2h-2v2zm-3 9h2v-2h-2v2zm0-6h2v-2h-2v2zm0 3h2v-2h-2v2z"
    }],
    "border_style": [{
        "d": "M11 16h2v-2h-2v2zm3 0h2v-2h-2v2zm-9 0h2v-2h-2v2zm3 0h2v-2h-2v2zm6-3h2v-2h-2v2zm0-3h2v-2h-2v2zm-12-8v14h2v-12h12v-2h-14zm12 5h2v-2h-2v2z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "border_top": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M5 10h2v-2h-2v2zm-3 6h2v-2h-2v2zm6 0h2v-2h-2v2zm0-3h2v-2h-2v2zm-3 3h2v-2h-2v2zm-3-3h2v-2h-2v2zm6-3h2v-2h-2v2zm-6-3h2v-2h-2v2zm0 3h2v-2h-2v2zm12 0h2v-2h-2v2zm0 3h2v-2h-2v2zm0-6h2v-2h-2v2zm-12-5v2h14v-2h-14zm6 5h2v-2h-2v2zm3 9h2v-2h-2v2zm0-6h2v-2h-2v2zm3 6h2v-2h-2v2z"
    }],
    "border_vertical": [{
        "d": "M5 16h2v-2h-2v2zm-3-9h2v-2h-2v2zm0-3h2v-2h-2v2zm3 6h2v-2h-2v2zm0-6h2v-2h-2v2zm-3 12h2v-2h-2v2zm0-6h2v-2h-2v2zm0 3h2v-2h-2v2zm12-11v2h2v-2h-2zm0 8h2v-2h-2v2zm-6 6h2v-14h-2v14zm6 0h2v-2h-2v2zm0-9h2v-2h-2v2zm0 6h2v-2h-2v2zm-3 3h2v-2h-2v2zm0-6h2v-2h-2v2zm0-6h2v-2h-2v2z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "format_align_center": [{
        "d": "M4 14v2h10v-2h-10zm0-8v2h10v-2h-10zm-2 6h14v-2h-14v2zm0-10v2h14v-2h-14z"
    }],
    "format_align_justify": [{
        "d": "M2 16h14v-2h-14v2zm0-4h14v-2h-14v2zm0-10v2h14v-2h-14zm0 6h14v-2h-14v2z"
    }],
    "format_align_left": [{
        "d": "M2 16h10v-2h-10v2zm10-10h-10v2h10v-2zm-10-4v2h14v-2h-14zm0 10h14v-2h-14v2z"
    }],
    "format_align_right": [{
        "d": "M6 16h10v-2h-10v2zm-4-4h14v-2h-14v2zm0-10v2h14v-2h-14zm4 6h10v-2h-10v2z"
    }],
    "format_bold": [{
        "d": "M11.63 7.82c.83-.58 1.37-1.44 1.37-2.32 0-1.93-1.57-3.5-3.5-3.5h-5.5v12h6.25c1.79 0 3.25-1.46 3.25-3.25 0-1.3-.77-2.41-1.87-2.93zm-5.13-3.82h2.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-2.75v-3zm3.25 8h-3.25v-3h3.25c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "format_clear": [{
        "d": "M0 0h18v18h-18zm0 0h18v18h-18zm0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M2.27 4.55l5.16 5.15-2.43 5.3h2.5l1.64-3.58 4.59 4.58 1.27-1.27-11.45-11.46-1.28 1.28zm3.55-1.55l2 2h1.76l-.55 1.21 1.71 1.71 1.34-2.92h3.92v-2h-10.18z"
    }],
    "format_color_fill": [{
        "fill-opacity": ".36",
        "d": "M0 15h18v3h-18z"
    }, {
        "d": "M14.5 8.87s-1.5 1.62-1.5 2.62c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.99-1.5-2.62-1.5-2.62zm-1.79-2.08l-6.8-6.79-1.06 1.06 1.59 1.59-4.15 4.14c-.39.39-.39 1.02 0 1.41l4.5 4.5c.2.2.45.3.71.3s.51-.1.71-.29l4.5-4.5c.39-.39.39-1.03 0-1.42zm-8.5.21l3.29-3.29 3.29 3.29h-6.58z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "format_color_reset": [{
        "d": "M0 0h18v18h-18zm0 0h18v18h-18zm0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M14 11c0-3.33-5-9-5-9s-.85.97-1.85 2.33l6.83 6.83.02-.16zm-10.45-7.73l-1.28 1.28 2.89 2.89c-.67 1.25-1.16 2.52-1.16 3.56 0 2.76 2.24 5 5 5 1.31 0 2.49-.52 3.39-1.34l2.34 2.34 1.27-1.27-12.45-12.46z"
    }],
    "format_color_text": [{
        "fill-opacity": ".36",
        "d": "M0 15h18v3h-18z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M10 1h-2l-4.5 12h2l1.12-3h4.75l1.12 3h2l-4.49-12zm-2.62 7l1.62-4.33 1.62 4.33h-3.24z"
    }],
    "format_indent_decrease": [{
        "d": "M10 10h-8v2h8v-2zm0-4h-8v2h8v-2zm-8 10h14v-2h-14v2zm14-3.5v-7l-3.5 3.5 3.5 3.5zm-14-10.5v2h14v-2h-14z"
    }],
    "format_indent_increase": [{
        "d": "M8 12h8v-2h-8v2zm-2.5-3l-3.5-3.5v7l3.5-3.5zm-3.5 7h14v-2h-14v2zm0-14v2h14v-2h-14zm6 6h8v-2h-8v2z"
    }],
    "format_italic": [{
        "d": "M7 2v2h2.58l-3.66 8h-2.92v2h8v-2h-2.58l3.66-8h2.92v-2z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "format_line_spacing": [{
        "d": "M9 15h9v-2h-9v2zm0-12v2h9v-2h-9zm-1.5 2l-3.5-3.5-3.5 3.5h2.5v8h-2.5l3.5 3.5 3.5-3.5h-2.5v-8h2.5zm1.5 5h9v-2h-9v2z"
    }],
    "format_list_bulleted": [{
        "d": "M7 10h9v-2h-9v2zm0-7v2h9v-2h-9zm0 12h9v-2h-9v2zm-4-5h2v-2h-2v2zm0-7v2h2v-2h-2zm0 12h2v-2h-2v2z"
    }],
    "format_list_numbered": [{
        "d": "M2 13h2v.5h-1v1h1v.5h-2v1h3v-4h-3v1zm0-5h1.8l-1.8 2.1v.9h3v-1h-1.8l1.8-2.1v-.9h-3v1zm1-2h1v-4h-2v1h1v3zm4-3v2h9v-2h-9zm0 12h9v-2h-9v2zm0-5h9v-2h-9v2z"
    }],
    "format_paint": [{
        "d": "M13 3c0-.55-.45-1-1-1h-8c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1h1.5v3h-7.5v8h2v-6.5h7v-5.5h-3v-1z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "format_quote": [{
        "d": "M10 5v5h2.75l-1.75 3h2.25l1.75-3v-5h-5zm-7 5h2.75l-1.75 3h2.25l1.75-3v-5h-5v5z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "format_size": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M1 9h3v6h2v-6h3v-2h-8v2zm6-6v2h4v10h2v-10h4v-2h-10z"
    }],
    "format_strikethrough": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M8 15h2v-4h-2v4zm-4-13v2h4v3h2v-3h4v-2h-10zm-1 8h12v-2h-12v2z"
    }],
    "format_textdirection_l_to_r": [{
        "d": "M6 7v5h2v-10h1v10h2v-10h1v-1h-6c-1.66 0-3 1.34-3 3s1.34 3 3 3zm10 8l-3-3v2h-11v2h11v2l3-3z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "format_textdirection_r_to_l": [{
        "d": "M7 7v5h2v-10h1v10h2v-10h1v-1h-6c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-2 11v-2h11v-2h-11v-2l-3 3 3 3z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "format_underline": [{
        "d": "M9 13c2.76 0 5-2.24 5-5v-7h-2.5v7c0 1.38-1.12 2.5-2.5 2.5s-2.5-1.12-2.5-2.5v-7h-2.5v7c0 2.76 2.24 5 5 5zm-6 2v2h12v-2h-12z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "functions": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M14 2h-10v1.8l5.5 5.2-5.5 5.2v1.8h10v-2h-6.9l4.9-5-4.9-5h6.9z"
    }],
    "insert_chart": [{
        "d": "M16 1h-14c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-14c0-.55-.45-1-1-1zm-9 12h-2v-5h2v5zm3 0h-2v-8h2v8zm3 0h-2v-4h2v4z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "insert_comment": [{
        "d": "M17 3c0-.55-.45-1-1-1h-14c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h11.5l3.5 3v-15zm-4 8h-8v-2h8v2zm0-3h-8v-2h8v2z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "insert_drive_file": [{
        "d": "M4 1c-.55 0-.99.45-.99 1l-.01 14c0 .55.44 1 1 1h10c.55 0 1-.45 1-1v-10l-5-5h-6zm6 5v-4l4 4h-4z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "insert_emoticon": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M6 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm6 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-3 5.5c2.14 0 3.92-1.5 4.38-3.5h-8.76c.46 2 2.24 3.5 4.38 3.5zm0-12.5c-4.43 0-8 3.58-8 8s3.57 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
    }],
    "insert_invitation": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M13 9h-4v4h4v-4zm3-7h-1v-2h-2v2h-8v-2h-2v2h-1c-.55 0-1 .45-1 1v13c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-13c0-.55-.45-1-1-1zm-1 13h-12v-9h12v9z"
    }],
    "insert_link": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M1.9 9c0-1.16.94-2.1 2.1-2.1h4v-1.9h-4c-2.21 0-4 1.79-4 4s1.79 4 4 4h4v-1.9h-4c-1.16 0-2.1-.94-2.1-2.1zm12.1-4h-4v1.9h4c1.16 0 2.1.94 2.1 2.1 0 1.16-.94 2.1-2.1 2.1h-4v1.9h4c2.21 0 4-1.79 4-4s-1.79-4-4-4zm-8 5h6v-2h-6v2z"
    }],
    "insert_photo": [{
        "d": "M16 1h-14c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-14c0-.55-.45-1-1-1zm-12.5 12l2.75-3.54 1.96 2.36 2.75-3.54 3.54 4.72h-11z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "merge_type": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M9 1.5l-3.5 3.5h2.5v4.59l-5 5 1.41 1.41 5.59-5.59v-5.41h2.5l-3.5-3.5zm3 10.09l-1.41 1.41 3 3 1.41-1.41-3-3z"
    }],
    "mode_comment": [{
        "d": "M17 3c0-.55-.45-1-1-1h-14c-.55 0-1 .45-1 1v11c0 .55.45 1 1 1h11.5l3.5 3v-15z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "mode_edit": [{
        "d": "M2 12.88v3.12h3.12l8.88-8.88-3.12-3.12-8.88 8.88zm14.76-8.51c.33-.33.33-.85 0-1.18l-1.95-1.95c-.33-.33-.85-.33-1.18 0l-1.63 1.64 3.12 3.12 1.64-1.63z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "publish": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M3 2v2h12v-2h-12zm0 9h3v5h6v-5h3l-6-6-6 6z"
    }],
    "vertical_align_bottom": [{
        "d": "M12.5 9h-2.5v-7h-2v7h-2.5l3.5 3.5 3.5-3.5zm-9.5 5v2h12v-2h-12z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "vertical_align_center": [{
        "d": "M12.5 3h-2.5v-3h-2v3h-2.5l3.5 3.5 3.5-3.5zm-9.5 5v2h12v-2h-12zm2.5 7h2.5v3h2v-3h2.5l-3.5-3.5-3.5 3.5z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "vertical_align_top": [{
        "d": "M3 2v2h12v-2h-12zm2.5 7h2.5v7h2v-7h2.5l-3.5-3.5-3.5 3.5z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "wrap_text": [{
        "d": "M16 3h-14v2h14v-2zm-14 12h4v-2h-4v2zm11.5-7h-11.5v2h11.75c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-2.75v-2l-3 3 3 3v-2h2.5c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "attachment": [{
        "d": "M15 5h-11c-2.21 0-4 1.79-4 4s1.79 4 4 4h10v-1h-10c-1.66 0-3-1.34-3-3s1.34-3 3-3h11c1.1 0 2 .9 2 2s-.9 2-2 2h-9c-.55 0-1-.45-1-1s.45-1 1-1h8v-1h-8c-1.1 0-2 .9-2 2s.9 2 2 2h9c1.66 0 3-1.34 3-3s-1.34-3-3-3z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "cloud_circle": [{
        "d": "M9 1c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm3.5 11h-6.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5h.18c.42-1.16 1.52-2 2.82-2 1.66 0 3 1.34 3 3h.5c1.1 0 2 .9 2 2s-.9 2-2 2z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "folder": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M10 5l-2-2h-5c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1h-5z"
    }],
    "folder_open": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M15 5h-5l-2-2h-5c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1zm-1 8h-10v-6h10v6z"
    }],
    "folder_shared": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M16 4h-6l-2-2h-6c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-10c0-.55-.45-1-1-1zm-4.5 2.75c.97 0 1.75.78 1.75 1.75s-.78 1.75-1.75 1.75-1.75-.78-1.75-1.75.78-1.75 1.75-1.75zm3.5 7.25h-7v-1.25c0-1.17 2.33-1.75 3.5-1.75s3.5.58 3.5 1.75v1.25z"
    }],
    "apps": [{
        "d": "M2 10h3v-3h-3v3zm0-5h3v-3h-3v3zm0 10h3v-3h-3v3zm5 0h3v-3h-3v3zm5-5h3v-3h-3v3zm-5 0h3v-3h-3v3zm5 5h3v-3h-3v3zm0-13v3h3v-3h-3zm-5 3h3v-3h-3v3z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "arrow_back": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M15 8.25h-9.13l4.19-4.19-1.06-1.06-6 6 6 6 1.06-1.06-4.19-4.19h9.13v-1.5z"
    }],
    "arrow_drop_down": [{
        "d": "M5 8l4 4 4-4z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "arrow_drop_up": [{
        "d": "M9 6l-4 4h8z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "arrow_forward": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M9 3l-1.06 1.06 4.19 4.19h-9.13v1.5h9.13l-4.19 4.19 1.06 1.06 6-6z"
    }],
    "cancel": [{
        "d": "M9 1c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm4 10.87l-1.13 1.13-2.87-2.87-2.87 2.87-1.13-1.13 2.87-2.87-2.87-2.87 1.13-1.13 2.87 2.87 2.87-2.87 1.13 1.13-2.87 2.87 2.87 2.87z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "check": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M6.61 11.89l-3.11-3.11-1.06 1.06 4.17 4.16 8.95-8.95-1.06-1.05z"
    }],
    "chevron_left": [{
        "d": "M11.56 5.56l-1.06-1.06-4.5 4.5 4.5 4.5 1.06-1.06-3.44-3.44z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "chevron_right": [{
        "d": "M7.5 4.5l-1.06 1.06 3.44 3.44-3.44 3.44 1.06 1.06 4.5-4.5z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "close": [{
        "d": "M0 0h18v18h-18zm0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M14.53 4.53l-1.06-1.06-4.47 4.47-4.47-4.47-1.06 1.06 4.47 4.47-4.47 4.47 1.06 1.06 4.47-4.47 4.47 4.47 1.06-1.06-4.47-4.47z"
    }],
    "expand_less": [{
        "d": "M9 6l-4.5 4.5 1.06 1.06 3.44-3.44 3.44 3.44 1.06-1.06z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "expand_more": [{
        "d": "M12.44 6.44l-3.44 3.44-3.44-3.44-1.06 1.06 4.5 4.5 4.5-4.5z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "fullscreen": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M4.5 11h-1.5v4h4v-1.5h-2.5v-2.5zm-1.5-4h1.5v-2.5h2.5v-1.5h-4v4zm10.5 6.5h-2.5v1.5h4v-4h-1.5v2.5zm-2.5-10.5v1.5h2.5v2.5h1.5v-4h-4z"
    }],
    "fullscreen_exit": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M3 12.5h2.5v2.5h1.5v-4h-4v1.5zm2.5-7h-2.5v1.5h4v-4h-1.5v2.5zm5.5 9.5h1.5v-2.5h2.5v-1.5h-4v4zm1.5-9.5v-2.5h-1.5v4h4v-1.5h-2.5z"
    }],
    "menu": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M2 13.5h14v-1.5h-14v1.5zm0-4h14v-1.5h-14v1.5zm0-5.5v1.5h14v-1.5h-14z"
    }],
    "more_horiz": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M4 7.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm10 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-5 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
    }],
    "more_vert": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M9 5.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zm0 2c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
    }],
    "refresh": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M9 13.5c-2.49 0-4.5-2.01-4.5-4.5s2.01-4.5 4.5-4.5c1.24 0 2.36.52 3.17 1.33l-2.17 2.17h5v-5l-1.76 1.76c-1.09-1.08-2.58-1.76-4.24-1.76-3.31 0-5.99 2.69-5.99 6s2.68 6 5.99 6c2.97 0 5.43-2.16 5.9-5h-1.52c-.46 2-2.24 3.5-4.38 3.5z"
    }],
    "unfold_less": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M5.56 14.44l1.06 1.06 2.38-2.38 2.38 2.38 1.06-1.06-3.44-3.44-3.44 3.44zm6.88-10.88l-1.06-1.06-2.38 2.38-2.38-2.38-1.06 1.06 3.44 3.44 3.44-3.44z"
    }],
    "unfold_more": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M9 4.12l2.38 2.38 1.06-1.06-3.44-3.44-3.44 3.44 1.06 1.06 2.38-2.38zm0 9.76l-2.38-2.38-1.06 1.06 3.44 3.44 3.44-3.44-1.06-1.06-2.38 2.38z"
    }],
    "adb": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M4 12c0 2.76 2.24 5 5 5s5-2.24 5-5v-3h-10v3zm7.95-8.91l1.5-1.5-.59-.59-1.65 1.65c-.67-.34-1.41-.54-2.21-.54s-1.54.2-2.21.54l-1.65-1.65-.58.59 1.5 1.5c-1.25.91-2.06 2.36-2.06 4.02v.89h10v-.89c0-1.66-.81-3.11-2.05-4.02zm-4.95 2.91h-1v-1h1v1zm5 0h-1v-1h1v1z"
    }],
    "event_note": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M13 7h-8v2h8v-2zm-3 3h-5v2h5v-2zm5-8h-1v-1h-2v1h-6v-1h-2v1h-1c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-12c0-.55-.45-1-1-1zm-1 12h-10v-8h10v8z"
    }],
    "vibration": [{
        "d": "M0 11h1v-4h-1v4zm2 2h1v-8h-1v8zm15-6v4h1v-4h-1zm-2 6h1v-8h-1v8zm-2.5-11h-7c-.83 0-1.5.67-1.5 1.5v11c0 .83.67 1.5 1.5 1.5h7c.83 0 1.5-.67 1.5-1.5v-11c0-.83-.67-1.5-1.5-1.5zm0 12.5h-7v-11h7v11z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "cake": [{
        "d": "M9 5c.83 0 1.5-.67 1.5-1.5 0-.28-.08-.55-.21-.77l-1.29-2.23-1.29 2.23c-.13.22-.21.49-.21.77 0 .83.67 1.5 1.5 1.5zm6 10v-3c0-.55-.45-1-1-1h-1v-2c0-.55-.45-1-1-1h-2v-2h-2v2h-2c-.55 0-1 .45-1 1v2h-1c-.55 0-1 .45-1 1v3h-2v2h16v-2h-2z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "domain": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M14 8h-1v1h1v-1zm-5-3v-3h-8v14h16v-11h-8zm-5 9h-1v-1h1v1zm0-3h-1v-1h1v1zm0-3h-1v-1h1v1zm0-3h-1v-1h1v1zm3 9h-1v-1h1v1zm0-3h-1v-1h1v1zm0-3h-1v-1h1v1zm0-3h-1v-1h1v1zm8 9h-6v-7h6v7zm-4-6h-1v1h1v-1zm3 4h-1v1h1v-1zm-3 0h-1v1h1v-1z"
    }],
    "group": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M6 8c1.11 0 2-.9 2-2s-.89-2-2-2c-1.1 0-2 .9-2 2s.9 2 2 2zm6 0c1.11 0 2-.9 2-2s-.89-2-2-2c-1.11 0-2 .9-2 2s.9 2 2 2zm-6 1.2c-1.67 0-5 .83-5 2.5v1.3h10v-1.3c0-1.67-3.33-2.5-5-2.5zm6 0c-.25 0-.54.02-.84.06.79.6 1.34 1.4 1.34 2.44v1.3h4.5v-1.3c0-1.67-3.33-2.5-5-2.5z"
    }],
    "group_add": [{
        "d": "M9 8c1.11 0 2-.9 2-2s-.89-2-2-2c-1.1 0-2 .9-2 2s.9 2 2 2zm4 0c1.11 0 2-.9 2-2s-.89-2-2-2c-.36 0-.69.1-.98.27.3.51.48 1.1.48 1.73s-.18 1.22-.48 1.73c.29.17.63.27.98.27zm-4 1.2c-1.67 0-5 .83-5 2.5v1.3h10v-1.3c0-1.67-3.33-2.5-5-2.5zm-4-2.2h-2v-2h-1v2h-2v1h2v2h1v-2h2v-1zm9.23 2.31c.75.6 1.27 1.38 1.27 2.39v1.3h2.5v-1.3c0-1.31-2.07-2.11-3.77-2.39z"
    }],
    "location_city": [{
        "d": "M12 8v-4.5l-2.5-2.5-2.5 2.5v1.5h-5v11h15v-8h-5zm-7 6h-1v-1h1v1zm0-3h-1v-1h1v1zm0-3h-1v-1h1v1zm5 6h-1v-1h1v1zm0-3h-1v-1h1v1zm0-3h-1v-1h1v1zm0-3h-1v-1h1v1zm5 9h-1v-1h1v1zm0-3h-1v-1h1v1z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "mood": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M6 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm6 0c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-3 5.5c2.14 0 3.92-1.5 4.38-3.5h-8.76c.46 2 2.24 3.5 4.38 3.5zm0-12.5c-4.43 0-8 3.58-8 8s3.57 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
    }],
    "pages": [{
        "d": "M5.5 10h-3.5v5c0 .55.45 1 1 1h5v-3.5l-3.5 1 1-3.5zm-3.5-7v5h3.5l-1-3.5 3.5 1v-3.5h-5c-.55 0-1 .45-1 1zm13-1h-5v3.5l3.5-1-1 3.5h3.5v-5c0-.55-.45-1-1-1zm-1.5 11.5l-3.5-1v3.5h5c.55 0 1-.45 1-1v-5h-3.5l1 3.5z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "people": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M6 8c1.11 0 2-.9 2-2s-.89-2-2-2c-1.1 0-2 .9-2 2s.9 2 2 2zm6 0c1.11 0 2-.9 2-2s-.89-2-2-2c-1.11 0-2 .9-2 2s.9 2 2 2zm-6 1.2c-1.67 0-5 .83-5 2.5v1.3h10v-1.3c0-1.67-3.33-2.5-5-2.5zm6 0c-.25 0-.54.02-.84.06.79.6 1.34 1.4 1.34 2.44v1.3h4.5v-1.3c0-1.67-3.33-2.5-5-2.5z"
    }],
    "person": [{
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }, {
        "d": "M9 8c1.66 0 2.99-1.34 2.99-3s-1.33-3-2.99-3c-1.66 0-3 1.34-3 3s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5v2.5h14v-2.5c0-2.33-4.67-3.5-7-3.5z"
    }],
    "person_add": [{
        "d": "M10 8c1.66 0 2.99-1.34 2.99-3s-1.33-3-2.99-3c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-6 2v-2h2v-2h-2v-2h-2v2h-2v2h2v2h2zm6 0c-2.33 0-7 1.17-7 3.5v2.5h14v-2.5c0-2.33-4.67-3.5-7-3.5z"
    }],
    "person_outline": [{
        "d": "M9 10c-2.33 0-7 1.17-7 3.5v2.5h14v-2.5c0-2.33-4.67-3.5-7-3.5zm5.29 4.29h-10.58v-.79c.1-.49 2.59-1.79 5.29-1.79s5.19 1.3 5.29 1.79v.79zm-5.29-5.29c2.22 0 4-1.79 4-4s-1.78-4-4-4c-2.21 0-3.99 1.79-3.99 4s1.78 4 3.99 4zm0-6.29c1.26 0 2.28 1.03 2.28 2.29s-1.02 2.29-2.28 2.29c-1.25 0-2.28-1.03-2.28-2.29s1.03-2.29 2.28-2.29z"
    }],
    "poll": [{
        "d": "M16 1h-14c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-14c0-.55-.45-1-1-1zm-9 12h-2v-5h2v5zm3 0h-2v-8h2v8zm3 0h-2v-4h2v4z"
    }, {
        "d": "M0 0h18v18h-18z",
        "fill": "none"
    }],
    "whatshot": [{
        "d": "M10.19 1.5s.49 1.99.49 3.6c0 1.55-1.01 2.8-2.56 2.8s-2.72-1.25-2.72-2.8l.02-.27c-1.51 1.81-2.42 4.13-2.42 6.67 0 3.31 2.69 6 6 6s6-2.69 6-6c0-4.05-1.88-7.65-4.81-10zm-1.28 13.5c-1.34 0-2.42-1.05-2.42-2.35 0-1.22.78-2.07 2.11-2.34 1.33-.27 2.7-.91 3.46-1.93.29.97.45 1.99.45 3.03 0 1.98-1.62 3.59-3.6 3.59z"
    }, {
        "d": "M0 .5h18v18h-18z",
        "fill": "none"
    }]
};